var _defs, _rect, _g, _g2, _g3, _g4, _g5, _g6, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyFlowDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "usdGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#133B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A1E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "usdcGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#133B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A1E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cadGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#133B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A1E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cadcGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#133B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A1E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ngnGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#133B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A1E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orangeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EB866A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E96543"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 3,
    dy: 3,
    stdDeviation: 5,
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 7,
    refX: 10,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#E96543"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "#FFFFFF",
    rx: 10,
    ry: 10,
    transform: "translate(0, 30)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E96543",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)",
    transform: "translate(0, 30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170 120 H 380",
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 1000,
    to: 0,
    dur: "30s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10,15",
    dur: "7.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 170 320 H 380",
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 1000,
    to: 0,
    dur: "30s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10,15",
    dur: "7.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 500 120 H 550 V 210 H 620",
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 1000,
    to: 0,
    dur: "30s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10,15",
    dur: "7.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 500 320 H 550 V 210 H 620",
    fill: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 1000,
    to: 0,
    dur: "30s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "10,15",
    dur: "7.5s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 20,
    ry: 20,
    fill: "url(#usdGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "USD"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "$"), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 20,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "18;22;18",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 310)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 20,
    ry: 20,
    fill: "url(#cadGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "CAD"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 40,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "C$"), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 20,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "18;22;18",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 20,
    ry: 20,
    fill: "url(#usdcGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "USDC"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "\u20BF"), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;18;14",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "$"), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 16,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;18;14",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 310)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 20,
    ry: 20,
    fill: "url(#cadcGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "CADC"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "\u20BF"), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;18;14",
    dur: "20s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "C$"), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 60,
    r: 16,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;18;14",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 20,
    ry: 20,
    fill: "url(#ngnGradient)",
    filter: "url(#shadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "NGN"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 20,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "\u20A6"), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 20,
    r: 16,
    fill: "url(#orangeGradient)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "14;18;14",
    dur: "20s",
    repeatCount: "indefinite"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 20,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#133B57",
    textAnchor: "middle"
  }, "Cross-Border Currency Flow")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 500,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#475569",
    textAnchor: "middle",
    opacity: 0.7
  }, "Powered by Kavodax")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyFlowDiagram);
export default __webpack_public_path__ + "static/media/currency-flow-diagram.cf2f00afd7068658ac42916019e2bc9e.svg";
export { ForwardRef as ReactComponent };